/**
 * @ncdoc Service
 * @param $http
 * @param environment
 * @param User
 * @returns {{create: create}}
 */
export default function viewsService($http, environment, User) {
  'ngInject';
  /**
   * @description Send data to view endpoint
   * @param data
   */
  function send(data) {
    $http({
      url: `${environment.api.baseUrl}/views` ,
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      data
    });
  }

  /**
   * @description build view data.
   * @param objectType
   * @param objectId
   */
  function create(objectType, objectId) {
    send({
      modelType: objectType,
      modelId: objectId,
      data: {
        user: User.loggedIn() ? User.currentUser.id : null,
        time: Date.now()
      }
    });
  }

  return {
    create
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/services/views/views.service.js
 **/